// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"2cc441e8","676":"76dbd805","720":"f68e5060","774":"33de4997","787":"1579013f","883":"4b98b320"}[chunkId] + ".chunk.js";
};